import React, { useState } from 'react';
import Button from '../button/Button';
import Partner from '../partner/Partner';

import img from '../../assets/images/layouts/about-02.png'; // You can change this to a single hero-style image

function About(props) {

    const [dataBlock] = useState({
        subheading: 'Who We Are',
        heading: 'NXTLVL Nights — Where Orlando Gets Wild',
        desc1: 'We don’t just throw parties — we set the city on fire. NXTLVL is the top-tier nightlife experience in Orlando. From reggaeton to hip-hop to global beats, we bring the heat and keep it moving all weekend.',
        desc2: 'Whether you’re here to flex, vibe, or disappear into the music, we’ve got your night. Come correct or don’t come at all. This isn’t for the faint of heart — it’s for those living NXTLVL.'
    });

    return (
        <section className="about s2">
            <div className="shape"></div>
            <div className="shape right"></div>
            <div className="container">
                <div className="row">
                    <div className="col-12">
                        <div className="block-text center pd-0">
                            <h6 className="sub-heading"><span>{dataBlock.subheading}</span></h6>
                            <h3 className="heading pd">{dataBlock.heading}</h3>
                        </div>

                        <div className="about__main center" data-aos="fade-up" data-aos-duration="3000">
                            <img src={img} alt="nxtlvl" />
                            <p className="mb-17">{dataBlock.desc1}</p>
                            <p className="mb-30">{dataBlock.desc2}</p>
{/*                             <Button title="More About Us" link="/about" />
 */}                        </div>

                        <Partner />
                    </div>
                </div>
            </div>
        </section>
    );
}

export default About;